module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-Text.f2a4ad4c.otf";